import { keepPreviousData, useQuery } from "@tanstack/react-query";

export function useBlueprintQuery(x: number, y: number, z: number) {
  return useQuery({
    queryKey: ["blueprint", x, y, z],
    queryFn: async () => {
      const response = await fetch(
        `https://dust-blueprint-redstone.latticexyz.workers.dev/?x=${x}&y=${y}&z=${z}`,
      );
      if (!response.ok) return [];

      const data = await response.json();
      return data;
    },
    placeholderData: keepPreviousData,
    enabled: !!x && !!y && !!z,
  });
}
